import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'

const GlobalStyle = () => (
  <>
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
    <link href="https://fonts.googleapis.com/css2?family=Fraunces:ital,wght@0,400;0,700;0,900;1,400;1,700;1,900&family=Plus+Jakarta+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
    <style>{`
      :root {
        --cream:#FAF7F2;--cream-d:#F0EBE1;--plum:#1E1040;
        --bg:#0B1220;--card:#111827;--card-h:#1F2937;--navy:#0F172A;
        --text-dark:#1E1040;--text-light:#F8FAFC;
        --muted-dark:#6B7280;--muted-light:#94A3B8;
        --border-dark:rgba(30,16,64,0.1);--border-light:rgba(248,250,252,0.07);
        --accent:#0D9488;--accent-l:#14B8A6;--accent-d:#0F766E;
        --grad-acc:linear-gradient(135deg,#0D9488,#14B8A6);
        --grad-acc-pg:linear-gradient(135deg,#0F766E,#0D9488,#14B8A6);
        --glow-acc:rgba(13,148,136,0.25);
      }
      *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
      html{scroll-behavior:smooth;}
      body{background:var(--cream);color:var(--text-dark);font-family:'Plus Jakarta Sans',sans-serif;overflow-x:hidden;-webkit-font-smoothing:antialiased;}
      .lg-root{background:var(--cream);overflow-x:hidden;}
      .grad-acc{background:var(--grad-acc);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;}
      .grad-pg{background:var(--grad-acc-pg);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;}
      .lg-nav{position:fixed;top:36px;left:0;right:0;z-index:100;display:flex;align-items:center;justify-content:space-between;padding:20px 56px;transition:all 0.4s;}
      .lg-nav.scrolled-light{background:rgba(250,247,242,0.95);backdrop-filter:blur(24px);border-bottom:1px solid var(--border-dark);padding:14px 56px;box-shadow:0 2px 20px rgba(30,16,64,0.06);}
      .lg-nav.scrolled-dark{background:rgba(11,18,32,0.95);backdrop-filter:blur(24px);border-bottom:1px solid var(--border-light);padding:14px 56px;}
      .lg-nav-logo{font-family:'Fraunces',serif;font-size:22px;font-weight:900;color:var(--plum);text-decoration:none;cursor:pointer;border:none;background:none;transition:color 0.3s;}
      .lg-nav.scrolled-dark .lg-nav-logo{color:var(--text-light);}
      .lg-nav-logo span{color:var(--accent);font-style:italic;}
      .lg-nav-links{display:flex;align-items:center;gap:28px;}
      .lg-nav-link{text-decoration:none;font-size:14px;font-weight:500;transition:color 0.2s;background:none;border:none;cursor:pointer;font-family:'Plus Jakarta Sans',sans-serif;}
      .lg-nav-link.light{color:var(--muted-dark);}.lg-nav-link.light:hover{color:var(--plum);}
      .lg-nav-link.dark{color:var(--muted-light);}.lg-nav-link.dark:hover{color:var(--text-light);}
      .lg-nav-login{background:none;border:1.5px solid var(--border-dark);color:var(--plum);padding:9px 20px;border-radius:100px;font-size:14px;font-weight:600;cursor:pointer;transition:all 0.2s;font-family:'Plus Jakarta Sans',sans-serif;}
      .lg-nav-login:hover{border-color:var(--accent);color:var(--accent);}
      .lg-nav-cta{background:var(--grad-acc);color:#042f2e;padding:10px 24px;border-radius:100px;font-size:14px;font-weight:700;border:none;cursor:pointer;transition:all 0.25s;font-family:'Plus Jakarta Sans',sans-serif;box-shadow:0 4px 20px var(--glow-acc);}
      .lg-nav-cta:hover{transform:translateY(-1px);box-shadow:0 8px 30px var(--glow-acc);filter:brightness(1.08);}
      .lg-hero{min-height:100vh;padding:140px 56px 0;position:relative;overflow:hidden;display:grid;grid-template-columns:1fr 1fr;gap:60px;align-items:center;background:var(--cream);}
      .lg-hero::before{content:'';position:absolute;inset:0;background-image:radial-gradient(circle,rgba(30,16,64,0.06) 1px,transparent 1px);background-size:32px 32px;mask-image:radial-gradient(ellipse 80% 80% at 60% 40%,black 20%,transparent 80%);pointer-events:none;}
      .lg-orb{position:absolute;border-radius:50%;filter:blur(80px);pointer-events:none;}
      .lg-orb1{width:500px;height:500px;background:radial-gradient(circle,rgba(13,148,136,0.14),transparent 70%);top:-100px;right:-100px;animation:orbFloat 14s ease-in-out infinite;}
      .lg-orb2{width:350px;height:350px;background:radial-gradient(circle,rgba(20,184,166,0.12),transparent 70%);bottom:0;left:-80px;animation:orbFloat 12s ease-in-out infinite reverse;}
      .lg-orb3{width:200px;height:200px;background:radial-gradient(circle,rgba(34,197,94,0.08),transparent 70%);top:40%;left:25%;animation:orbFloat 9s ease-in-out infinite 2s;}
      @keyframes orbFloat{0%,100%{transform:translate(0,0) scale(1)}33%{transform:translate(20px,-30px) scale(1.06)}66%{transform:translate(-15px,15px) scale(0.96)}}
      .lg-hero-left{position:relative;z-index:2;}
      .lg-pill{display:inline-flex;align-items:center;gap:8px;background:rgba(13,148,136,0.08);border:1px solid rgba(13,148,136,0.25);color:var(--accent);font-size:12px;font-weight:700;padding:7px 16px;border-radius:100px;margin-bottom:28px;letter-spacing:0.05em;text-transform:uppercase;animation:fadeUp 0.7s ease both;}
      .lg-pill-dot{width:6px;height:6px;background:var(--accent);border-radius:50%;animation:blink 2s infinite;}
      @keyframes blink{0%,100%{opacity:1}50%{opacity:0.2}}
      .lg-h1{font-family:'Fraunces',serif;font-size:clamp(44px,5.5vw,80px);font-weight:900;line-height:0.96;letter-spacing:-2px;margin-bottom:24px;color:var(--plum);animation:fadeUp 0.7s ease 0.1s both;}
      .lg-hero-sub{font-size:18px;color:var(--muted-dark);line-height:1.7;max-width:520px;font-weight:400;margin-bottom:36px;animation:fadeUp 0.7s ease 0.2s both;}
      .lg-hero-sub strong{color:var(--plum);font-weight:700;}
      .lg-hero-actions{display:flex;align-items:center;gap:14px;flex-wrap:wrap;animation:fadeUp 0.7s ease 0.3s both;}
      .lg-btn-primary{background:var(--grad-acc);color:#042f2e;padding:15px 32px;border-radius:100px;font-size:15px;font-weight:700;border:none;cursor:pointer;font-family:'Plus Jakarta Sans',sans-serif;display:inline-flex;align-items:center;gap:8px;transition:all 0.25s;box-shadow:0 6px 24px var(--glow-acc);}
      .lg-btn-primary:hover{transform:translateY(-2px);box-shadow:0 16px 40px var(--glow-acc);filter:brightness(1.08);}
      .lg-btn-primary-lg{font-size:17px;padding:18px 44px;}
      .lg-btn-ghost-dark{background:none;border:2px solid var(--border-dark);color:var(--plum);padding:13px 28px;border-radius:100px;font-size:15px;font-weight:600;cursor:pointer;font-family:'Plus Jakarta Sans',sans-serif;transition:all 0.2s;}
      .lg-btn-ghost-dark:hover{border-color:var(--accent);color:var(--accent);}
      .lg-hero-trust{display:flex;align-items:center;gap:18px;margin-top:24px;flex-wrap:wrap;animation:fadeUp 0.7s ease 0.4s both;}
      .lg-trust-item{display:flex;align-items:center;gap:6px;font-size:13px;color:var(--muted-dark);font-weight:500;}
      .lg-trust-item::before{content:'✓';color:var(--accent);font-weight:800;}
      .lg-trust-div{width:3px;height:3px;background:rgba(30,16,64,0.15);border-radius:50%;}
      .lg-hero-right{position:relative;z-index:2;display:flex;align-items:center;justify-content:center;animation:fadeUp 0.7s ease 0.2s both;}
      .lg-pdf-wrap{position:relative;animation:pdfFloat 6s ease-in-out infinite;}
      @keyframes pdfFloat{0%,100%{transform:translateY(0) rotate(-1deg)}50%{transform:translateY(-18px) rotate(1deg)}}
      .lg-pdf{width:360px;background:#fff;border-radius:12px;box-shadow:0 60px 120px rgba(30,16,64,0.22),0 20px 40px rgba(30,16,64,0.12);overflow:hidden;border:1px solid rgba(30,16,64,0.08);}
      .lg-pdf-hdr{padding:24px 28px 16px;border-bottom:1px solid #F3F4F6;}
      .lg-pdf-brand{font-family:'Fraunces',serif;font-size:14px;font-weight:900;color:var(--plum);margin-bottom:3px;}
      .lg-pdf-brand span{color:var(--accent);font-style:italic;}
      .lg-pdf-title{font-family:'Fraunces',serif;font-size:20px;font-weight:900;color:var(--plum);letter-spacing:-0.5px;margin-top:14px;margin-bottom:4px;}
      .lg-pdf-sub{font-size:11px;color:#9CA3AF;letter-spacing:0.05em;}
      .lg-pdf-body{padding:16px 28px 20px;}
      .lg-pdf-stat-row{display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px;margin-bottom:16px;}
      .lg-pdf-stat{background:#F9FAFB;border-radius:8px;padding:10px 10px;border:1px solid #F3F4F6;}
      .lg-pdf-stat-l{font-size:9px;color:#9CA3AF;text-transform:uppercase;letter-spacing:0.06em;margin-bottom:2px;}
      .lg-pdf-stat-v{font-family:'Fraunces',serif;font-size:16px;font-weight:800;color:var(--plum);}
      .lg-pdf-stat-v.pos{color:var(--accent);}
      .lg-pdf-table{border:1px solid #F3F4F6;border-radius:8px;overflow:hidden;margin-bottom:12px;}
      .lg-pdf-row{display:grid;grid-template-columns:54px 1fr 62px;padding:8px 12px;font-size:11px;color:#4B5563;border-top:1px solid #F3F4F6;}
      .lg-pdf-row:first-child{border-top:none;}
      .lg-pdf-row-hd{background:#F9FAFB;font-size:9px;font-weight:700;color:#9CA3AF;text-transform:uppercase;letter-spacing:0.06em;padding:7px 12px;}
      .lg-pdf-row-ttl{background:rgba(13,148,136,0.08);border-top:1px solid rgba(13,148,136,0.2);font-weight:800;color:var(--plum);}
      .lg-pdf-merchant{font-weight:600;color:var(--plum);}
      .lg-pdf-amt{text-align:right;font-weight:600;}
      .lg-pdf-foot{font-size:10px;color:#9CA3AF;display:flex;align-items:center;gap:6px;padding-top:10px;border-top:1px solid #F3F4F6;}
      .lg-pdf-foot span{color:var(--accent);font-size:13px;}
      .lg-badge{position:absolute;background:var(--cream);border:1px solid rgba(30,16,64,0.1);border-radius:14px;padding:10px 14px;display:flex;align-items:center;gap:9px;box-shadow:0 16px 40px rgba(30,16,64,0.12);white-space:nowrap;font-size:12px;font-weight:600;color:var(--plum);}
      .lg-badge1{top:-10px;left:-110px;animation:bf1 5s ease-in-out infinite;}
      .lg-badge2{bottom:40px;right:-130px;animation:bf2 6s ease-in-out infinite;}
      .lg-badge3{top:45%;left:-120px;animation:bf3 7s ease-in-out infinite;}
      @keyframes bf1{0%,100%{transform:translateY(0)}50%{transform:translateY(-8px)}}
      @keyframes bf2{0%,100%{transform:translateY(0)}50%{transform:translateY(8px)}}
      @keyframes bf3{0%,100%{transform:translateY(0)}50%{transform:translateY(-5px)}}
      .lg-wave{height:120px;background:var(--cream);position:relative;overflow:hidden;margin-top:-1px;}
      .lg-wave::after{content:'';position:absolute;bottom:0;left:0;right:0;height:120px;background:var(--navy);clip-path:ellipse(55% 100% at 50% 100%);}
      .lg-wave-rev{height:100px;background:var(--bg);position:relative;overflow:hidden;}
      .lg-wave-rev::after{content:'';position:absolute;bottom:0;left:0;right:0;height:100px;background:var(--cream);clip-path:ellipse(55% 100% at 50% 100%);}
      .lg-dark{background:var(--bg);}
      .lg-eyebrow{font-size:11px;font-weight:700;letter-spacing:0.14em;text-transform:uppercase;margin-bottom:14px;display:flex;align-items:center;gap:10px;color:var(--accent-l);}
      .lg-eyebrow::before{content:'';width:22px;height:2px;border-radius:2px;background:var(--accent-l);}
      .lg-big-h{font-family:'Fraunces',serif;font-size:clamp(30px,4vw,54px);font-weight:900;letter-spacing:-1.5px;line-height:1.06;color:var(--text-light);}
      .lg-body-txt{font-size:17px;color:var(--muted-light);line-height:1.7;max-width:480px;margin-top:16px;}
      .lg-how{padding:100px 56px;background:var(--navy);}
      .lg-how-in{max-width:1100px;margin:0 auto;}
      .lg-how-hdr{text-align:center;margin-bottom:60px;}
      .lg-how-hdr .lg-eyebrow{justify-content:center;}
      .lg-how-steps{display:grid;grid-template-columns:repeat(3,1fr);gap:20px;}
      .lg-how-step{background:var(--card);border:1px solid var(--border-light);border-radius:20px;padding:32px;position:relative;transition:all 0.3s;}
      .lg-how-step:hover{background:var(--card-h);transform:translateY(-6px);box-shadow:0 20px 50px rgba(13,148,136,0.08);border-color:rgba(13,148,136,0.25);}
      .lg-how-num{font-family:'Fraunces',serif;font-size:72px;font-weight:900;line-height:0.9;background:var(--grad-acc);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;margin-bottom:16px;}
      .lg-how-t{font-family:'Fraunces',serif;font-size:22px;font-weight:800;color:var(--text-light);margin-bottom:10px;}
      .lg-how-d{font-size:14px;color:var(--muted-light);line-height:1.6;}
      .lg-mileage{padding:100px 56px;background:var(--card);border-top:1px solid var(--border-light);border-bottom:1px solid var(--border-light);}
      .lg-mileage-in{max-width:1100px;margin:0 auto;display:grid;grid-template-columns:1fr 1fr;gap:80px;align-items:center;}
      .lg-mile-card{background:var(--card-h);border:1px solid var(--border-light);border-radius:20px;padding:32px;}
      .lg-mile-trip{display:grid;grid-template-columns:auto 1fr auto;gap:14px;padding:14px 0;border-bottom:1px solid var(--border-light);align-items:center;}
      .lg-mile-trip:last-child{border-bottom:none;}
      .lg-mile-ic{width:36px;height:36px;border-radius:10px;background:rgba(13,148,136,0.12);border:1px solid rgba(13,148,136,0.25);display:flex;align-items:center;justify-content:center;font-size:16px;}
      .lg-mile-info{font-size:13px;color:var(--text-light);font-weight:600;margin-bottom:3px;}
      .lg-mile-sub{font-size:11px;color:var(--muted-light);}
      .lg-mile-val{text-align:right;}
      .lg-mile-mi{font-family:'Fraunces',serif;font-size:15px;font-weight:800;color:var(--accent-l);}
      .lg-mile-ded{font-size:10px;color:var(--muted-light);margin-top:2px;}
      .lg-mile-ttl{margin-top:16px;padding-top:16px;border-top:2px solid rgba(13,148,136,0.3);display:flex;justify-content:space-between;align-items:center;}
      .lg-mile-ttl-l{font-size:12px;color:var(--muted-light);text-transform:uppercase;letter-spacing:0.08em;font-weight:700;}
      .lg-mile-ttl-v{font-family:'Fraunces',serif;font-size:24px;font-weight:900;color:var(--accent-l);}
      .lg-fl{margin-top:32px;display:flex;flex-direction:column;gap:12px;}
      .lg-fli{display:flex;gap:14px;align-items:flex-start;padding:16px;border-radius:18px;border:1px solid transparent;transition:all 0.25s;}
      .lg-fli:hover{background:var(--card);border-color:var(--border-light);}
      .lg-f-num{width:28px;height:28px;border-radius:50%;flex-shrink:0;margin-top:2px;font-size:13px;font-weight:700;display:flex;align-items:center;justify-content:center;background:rgba(13,148,136,0.12);border:1px solid rgba(13,148,136,0.3);color:var(--accent-l);}
      .lg-f-title{font-size:15px;font-weight:700;margin-bottom:4px;color:var(--text-light);}
      .lg-f-desc{font-size:14px;color:var(--muted-light);line-height:1.6;}
      .lg-cat{padding:100px 56px;background:var(--bg);}
      .lg-cat-in{max-width:1100px;margin:0 auto;}
      .lg-cat-hdr{text-align:center;margin-bottom:50px;}
      .lg-cat-hdr .lg-eyebrow{justify-content:center;}
      .lg-cat-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:12px;}
      .lg-cat-c{background:var(--card);border:1px solid var(--border-light);border-radius:14px;padding:18px 16px;text-align:center;transition:all 0.25s;}
      .lg-cat-c:hover{background:var(--card-h);transform:translateY(-3px);border-color:rgba(13,148,136,0.25);}
      .lg-cat-ic{font-size:28px;margin-bottom:10px;}
      .lg-cat-t{font-size:13px;font-weight:700;color:var(--text-light);margin-bottom:4px;}
      .lg-cat-sub{font-size:11px;color:var(--muted-light);}
      .lg-who{padding:100px 56px;background:var(--bg);}
      .lg-who-in{max-width:1100px;margin:0 auto;}
      .lg-who-hdr{text-align:center;margin-bottom:50px;}
      .lg-who-hdr .lg-eyebrow{justify-content:center;}
      .lg-who-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:16px;}
      .lg-who-c{background:var(--card);border:1px solid var(--border-light);border-radius:16px;padding:24px;transition:all 0.25s;}
      .lg-who-c:hover{background:var(--card-h);border-color:rgba(13,148,136,0.25);transform:translateY(-3px);}
      .lg-who-ic{font-size:30px;margin-bottom:12px;}
      .lg-who-t{font-family:'Fraunces',serif;font-size:18px;font-weight:800;color:var(--text-light);margin-bottom:8px;}
      .lg-who-d{font-size:13px;color:var(--muted-light);line-height:1.55;}
      .lg-sample{padding:100px 56px;background:var(--navy);}
      .lg-sample-in{max-width:820px;margin:0 auto;text-align:center;}
      .lg-sample-in .lg-eyebrow{justify-content:center;}
      .lg-sample-h{font-family:'Fraunces',serif;font-size:clamp(28px,3.5vw,44px);font-weight:900;color:var(--text-light);margin-bottom:16px;line-height:1.1;letter-spacing:-1px;}
      .lg-sample-p{font-size:16px;color:var(--muted-light);margin-bottom:28px;line-height:1.7;}
      .lg-sample-btn{display:inline-flex;align-items:center;gap:10px;background:var(--accent);color:#042f2e;padding:16px 36px;border-radius:100px;font-weight:800;font-size:15px;text-decoration:none;box-shadow:0 8px 30px var(--glow-acc);transition:all 0.25s;}
      .lg-sample-btn:hover{transform:translateY(-2px);box-shadow:0 16px 40px var(--glow-acc);filter:brightness(1.08);}
      .lg-price{padding:100px 56px;background:var(--navy);text-align:center;}
      .lg-price-in{max-width:520px;margin:0 auto;}
      .lg-price-hdr .lg-eyebrow{justify-content:center;}
      .lg-pc{border:1px solid rgba(13,148,136,0.3);background:rgba(13,148,136,0.05);border-radius:24px;padding:40px 36px;text-align:left;position:relative;margin-top:48px;}
      .lg-pc-eyebrow{font-size:12px;color:var(--muted-light);margin-bottom:6px;text-transform:uppercase;letter-spacing:0.08em;font-weight:700;}
      .lg-pc-name{font-family:'Fraunces',serif;font-size:22px;font-weight:800;color:var(--text-light);margin-bottom:12px;}
      .lg-pc-price{font-family:'Fraunces',serif;font-size:72px;font-weight:900;letter-spacing:-2px;line-height:1;background:var(--grad-acc);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;}
      .lg-pc-price sup{font-size:30px;vertical-align:super;letter-spacing:0;}
      .lg-pc-period{font-size:14px;color:var(--muted-light);}
      .lg-pc-note{font-size:12px;color:var(--muted-light);margin:8px 0 24px;}
      .lg-pc-feats{display:flex;flex-direction:column;gap:10px;margin-bottom:28px;}
      .lg-pc-feat-item{font-size:14px;color:var(--muted-light);display:flex;align-items:center;gap:10px;}
      .lg-pc-feat-item::before{content:'✓';color:var(--accent-l);font-weight:800;font-size:14px;}
      .lg-pc-cta{width:100%;padding:16px;border-radius:100px;font-size:15px;font-weight:700;cursor:pointer;border:none;font-family:'Plus Jakarta Sans',sans-serif;background:var(--grad-acc);color:#042f2e;transition:all 0.2s;box-shadow:0 4px 20px var(--glow-acc);}
      .lg-pc-cta:hover{filter:brightness(1.08);transform:translateY(-1px);box-shadow:0 8px 30px var(--glow-acc);}
      .lg-cta{padding:120px 56px;text-align:center;position:relative;overflow:hidden;background:var(--cream);}
      .lg-cta::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse 60% 80% at 50% 50%,rgba(13,148,136,0.08) 0%,rgba(20,184,166,0.05) 50%,transparent 70%);}
      .lg-cta-in{position:relative;max-width:640px;margin:0 auto;}
      .lg-cta-h{font-family:'Fraunces',serif;font-size:clamp(34px,5vw,62px);font-weight:900;letter-spacing:-2px;line-height:1.05;margin-bottom:20px;color:var(--plum);}
      .lg-cta-sub{font-size:18px;color:var(--muted-dark);line-height:1.7;margin-bottom:36px;}
      .lg-footer{background:var(--cream-d);border-top:1px solid var(--border-dark);padding:64px 56px 36px;}
      .lg-foot-in{max-width:1240px;margin:0 auto;display:grid;grid-template-columns:2fr 1fr 1fr;gap:64px;margin-bottom:48px;}
      .lg-foot-logo{font-family:'Fraunces',serif;font-size:22px;font-weight:900;color:var(--plum);text-decoration:none;cursor:pointer;border:none;background:none;}
      .lg-foot-logo span{color:var(--accent);font-style:italic;}
      .lg-foot-sub{font-size:14px;color:var(--muted-dark);margin-top:10px;line-height:1.6;max-width:300px;}
      .lg-foot-col h4{font-size:11px;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;color:rgba(30,16,64,0.35);margin-bottom:18px;}
      .lg-foot-col a{display:block;font-size:14px;color:var(--muted-dark);text-decoration:none;margin-bottom:10px;transition:color 0.2s;cursor:pointer;}
      .lg-foot-col a:hover{color:var(--accent);}
      .lg-foot-btm{max-width:1240px;margin:0 auto;border-top:1px solid var(--border-dark);padding-top:28px;display:flex;justify-content:space-between;flex-wrap:wrap;gap:12px;}
      .lg-foot-copy{font-size:12px;color:rgba(30,16,64,0.25);}
      @keyframes fadeUp{from{opacity:0;transform:translateY(24px)}to{opacity:1;transform:translateY(0)}}
      .lg-reveal{opacity:0;transform:translateY(32px);transition:opacity 0.8s cubic-bezier(0.16,1,0.3,1),transform 0.8s cubic-bezier(0.16,1,0.3,1);}
      .lg-reveal.visible{opacity:1;transform:translateY(0);}
      .lg-reveal-left{opacity:0;transform:translateX(-32px);transition:opacity 0.8s cubic-bezier(0.16,1,0.3,1),transform 0.8s cubic-bezier(0.16,1,0.3,1);}
      .lg-reveal-left.visible{opacity:1;transform:translateX(0);}
      .lg-reveal-right{opacity:0;transform:translateX(32px);transition:opacity 0.8s cubic-bezier(0.16,1,0.3,1),transform 0.8s cubic-bezier(0.16,1,0.3,1);}
      .lg-reveal-right.visible{opacity:1;transform:translateX(0);}
      @media(max-width:900px){
        .lg-nav,.lg-nav.scrolled-light,.lg-nav.scrolled-dark{padding:16px 20px;}
        .lg-hero{grid-template-columns:1fr;padding:100px 24px 60px;min-height:auto;gap:32px;}
        .lg-hero-right{display:none;}
        .lg-how-steps{grid-template-columns:1fr;}
        .lg-mileage-in{grid-template-columns:1fr;gap:48px;}
        .lg-mileage{padding:60px 24px;}
        .lg-who-grid{grid-template-columns:1fr 1fr;}
        .lg-cat-grid{grid-template-columns:repeat(2,1fr);}
        .lg-foot-in{grid-template-columns:1fr;gap:32px;}
        .lg-price,.lg-cta,.lg-how,.lg-cat,.lg-sample,.lg-who{padding:60px 24px;}
        .lg-nav-link{display:none;}
        .lg-nav-login{padding:7px 14px;font-size:13px;}
      }
      @media(max-width:640px){
        .lg-nav,.lg-nav.scrolled-light,.lg-nav.scrolled-dark{padding:14px 16px;}
        .lg-nav-logo{font-size:19px;}
        .lg-nav-cta{padding:8px 16px;font-size:13px;}
        .lg-nav-links{gap:10px;}
        .lg-hero{padding:90px 16px 40px;gap:24px;}
        .lg-pill{font-size:10px;padding:6px 12px;margin-bottom:20px;}
        .lg-h1{font-size:clamp(36px,10vw,54px);letter-spacing:-1.5px;margin-bottom:18px;}
        .lg-hero-sub{font-size:15px;margin-bottom:24px;}
        .lg-btn-primary,.lg-btn-ghost-dark{width:100%;justify-content:center;padding:13px 22px;font-size:14px;}
        .lg-btn-primary-lg{padding:15px 28px;font-size:15px;}
        .lg-wave{height:70px;}.lg-wave::after{height:70px;}
        .lg-wave-rev{height:60px;}.lg-wave-rev::after{height:60px;}
        .lg-how,.lg-mileage,.lg-cat,.lg-sample,.lg-price,.lg-cta,.lg-who{padding:56px 16px;}
        .lg-big-h{font-size:clamp(26px,7.5vw,36px);letter-spacing:-1px;}
        .lg-body-txt{font-size:15px;}
        .lg-how-step{padding:24px;}
        .lg-how-num{font-size:56px;}
        .lg-how-t{font-size:19px;}
        .lg-who-grid{grid-template-columns:1fr;}
        .lg-cat-grid{gap:10px;}
        .lg-cat-c{padding:14px 10px;}
        .lg-cat-ic{font-size:24px;}
        .lg-cat-t{font-size:12px;}
        .lg-cat-sub{font-size:10px;}
        .lg-pc{padding:28px 22px;border-radius:18px;}
        .lg-pc-price{font-size:56px;}
        .lg-pc-price sup{font-size:26px;}
        .lg-sample-h{font-size:26px;}
        .lg-sample-p{font-size:15px;}
        .lg-cta-sub{font-size:16px;margin-bottom:28px;}
        .lg-footer{padding:48px 16px 28px;}
        .lg-foot-in{gap:32px;margin-bottom:32px;}
        .lg-foot-btm{flex-direction:column;gap:8px;}
        .lg-fli{padding:12px;gap:12px;}
        .lg-fl{gap:8px;margin-top:24px;}
        .lg-mile-card{padding:20px;}
        .lg-mile-ttl-v{font-size:20px;}
      }
      @media(max-width:380px){
        .lg-h1{font-size:36px;letter-spacing:-1px;}
        .lg-big-h{font-size:24px;}
        .lg-nav-cta{padding:7px 12px;font-size:12px;}
        .lg-nav-login{padding:6px 12px;font-size:12px;}
        .lg-nav-links{gap:8px;}
      }
    `}</style>
  </>
)

function AuthModal({ mode: initialMode, onClose, onSuccess }) {
  const [mode, setMode] = useState(initialMode)
  const [fullName, setFullName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [confirmed, setConfirmed] = useState(false)
  useEffect(() => { setError(''); setFullName(''); setEmail(''); setPassword('') }, [mode])
  useEffect(() => {
    const h = (e) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', h)
    return () => window.removeEventListener('keydown', h)
  }, [onClose])
  const handleLogin = async (e) => {
    e.preventDefault(); setLoading(true); setError('')
    const { data, error: err } = await supabase.auth.signInWithPassword({ email, password })
    if (err) { setError(err.message); setLoading(false); return }
    if (data.session) localStorage.setItem('mlog_refresh_token', data.session.refresh_token)
    onSuccess()
  }
  const handleSignUp = async (e) => {
    e.preventDefault(); setLoading(true); setError('')
    const { error: err } = await supabase.auth.signUp({ email, password, options: { data: { full_name: fullName } } })
    if (err) { setError(err.message); setLoading(false); return }
    setConfirmed(true); setLoading(false)
  }
  const handleForgot = async () => {
    if (!email) { setError('Enter your email address first.'); return }
    setLoading(true)
    const { error: err } = await supabase.auth.resetPasswordForEmail(email, { redirectTo: `${window.location.origin}/reset-password` })
    if (err) { setError(err.message) } else { alert(`Password reset link sent to ${email}`) }
    setLoading(false)
  }
  const inp = { width:'100%', padding:'11px 12px', borderRadius:'8px', border:'1.5px solid #E8EDF2', fontSize:'14px', outline:'none', boxSizing:'border-box', color:'#1B2B3A' }
  const lbl = { display:'block', fontSize:'13px', fontWeight:'500', color:'#1B2B3A', marginBottom:'5px' }
  return (
    <div style={{ position:'fixed',inset:0,zIndex:1000,background:'rgba(10,20,30,0.75)',backdropFilter:'blur(8px)',display:'flex',alignItems:'center',justifyContent:'center',padding:'20px' }} onClick={(e) => { if (e.target === e.currentTarget) onClose() }}>
      <div style={{ background:'#fff',borderRadius:'20px',padding:'36px 32px',width:'100%',maxWidth:'420px',position:'relative',boxShadow:'0 32px 80px rgba(0,0,0,0.3)' }}>
        <button onClick={onClose} style={{ position:'absolute',top:'16px',right:'16px',background:'#F7F9FC',border:'1px solid #E8EDF2',borderRadius:'50%',width:'32px',height:'32px',fontSize:'14px',color:'#8899AA',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center' }}>✕</button>
        <div style={{ textAlign:'center',fontSize:'26px',fontWeight:'900',marginBottom:'20px',fontFamily:"'Fraunces',serif",fontStyle:'italic' }}>
          <span style={{ color:'#1B2B3A',fontStyle:'normal' }}>Merq</span><span style={{ color:'#0D9488' }}> Log</span>
        </div>
        {confirmed ? (
          <div style={{ textAlign:'center' }}>
            <div style={{ fontSize:'48px',marginBottom:'16px' }}>✉️</div>
            <div style={{ fontSize:'20px',fontWeight:'700',color:'#1B2B3A',marginBottom:'10px' }}>Check your email!</div>
            <div style={{ fontSize:'14px',color:'#8899AA',lineHeight:'1.6' }}>We sent a confirmation link to <strong>{email}</strong>.</div>
            <button onClick={() => { setConfirmed(false); setMode('login') }} style={{ display:'block',width:'100%',marginTop:'20px',padding:'12px',background:'#0D9488',color:'#042f2e',border:'none',borderRadius:'10px',fontSize:'14px',fontWeight:'700',cursor:'pointer' }}>Go to sign in →</button>
          </div>
        ) : (
          <>
            <div style={{ display:'flex',background:'#F7F9FC',borderRadius:'10px',padding:'4px',marginBottom:'20px',gap:'4px' }}>
              {['login','signup'].map(m => (
                <button key={m} onClick={() => setMode(m)} style={{ flex:1,padding:'10px',borderRadius:'8px',border:'none',background:mode===m?'#fff':'transparent',fontSize:'14px',fontWeight:'500',color:mode===m?'#1B2B3A':'#8899AA',cursor:'pointer',boxShadow:mode===m?'0 1px 4px rgba(0,0,0,0.1)':'none',transition:'all 0.2s' }}>
                  {m==='login'?'Log in':'Start free trial'}
                </button>
              ))}
            </div>
            {mode==='signup' && <div style={{ background:'rgba(13,148,136,0.08)',color:'#0F766E',padding:'8px 12px',borderRadius:'8px',fontSize:'13px',textAlign:'center',marginBottom:'16px',fontWeight:'500' }}>✓ 14 days free · No credit card required</div>}
            <form onSubmit={mode==='login'?handleLogin:handleSignUp}>
              {mode==='signup' && <div style={{ marginBottom:'14px' }}><label style={lbl}>Full name</label><input style={inp} type="text" placeholder="Your name" value={fullName} onChange={e=>setFullName(e.target.value)} required /></div>}
              <div style={{ marginBottom:'14px' }}><label style={lbl}>Email</label><input style={inp} type="email" placeholder="you@email.com" value={email} onChange={e=>setEmail(e.target.value)} required /></div>
              <div style={{ marginBottom:'14px' }}><label style={lbl}>Password</label><input style={inp} type="password" placeholder={mode==='signup'?'Min 6 characters':'••••••••'} value={password} onChange={e=>setPassword(e.target.value)} required minLength={mode==='signup'?6:undefined} /></div>
              {error && <div style={{ background:'#FDECEA',color:'#A32D2D',padding:'10px 12px',borderRadius:'8px',fontSize:'13px',marginBottom:'14px' }}>{error}</div>}
              <button type="submit" disabled={loading} style={{ width:'100%',padding:'13px',background:'#0D9488',color:'#042f2e',border:'none',borderRadius:'10px',fontSize:'15px',fontWeight:'700',cursor:'pointer',marginTop:'4px' }}>
                {loading?(mode==='login'?'Signing in...':'Creating account...'):(mode==='login'?'Sign in →':'Start 14-day free trial →')}
              </button>
            </form>
            {mode==='login' && <button onClick={handleForgot} disabled={loading} style={{ width:'100%',background:'none',border:'none',color:'#8899AA',fontSize:'13px',cursor:'pointer',marginTop:'10px',textAlign:'center',padding:'4px' }}>Forgot password?</button>}
            {mode==='signup' && <div style={{ fontSize:'12px',color:'#8899AA',textAlign:'center',marginTop:'12px',lineHeight:'1.6' }}>By signing up you agree to our <a href="https://getmerq.com/terms.html" target="_blank" rel="noopener noreferrer" style={{color:'#0D9488'}}>Terms</a> and <a href="https://getmerq.com/privacy.html" target="_blank" rel="noopener noreferrer" style={{color:'#0D9488'}}>Privacy Policy</a>.</div>}
            <div style={{ textAlign:'center',marginTop:'14px',fontSize:'13px',color:'#8899AA' }}>
              {mode==='login'?<>Don't have an account? <button onClick={()=>setMode('signup')} style={{background:'none',border:'none',color:'#0D9488',fontSize:'13px',cursor:'pointer',fontWeight:'500'}}>Start free trial</button></>:<>Already have an account? <button onClick={()=>setMode('login')} style={{background:'none',border:'none',color:'#0D9488',fontSize:'13px',cursor:'pointer',fontWeight:'500'}}>Log in</button></>}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default function Landing({ session }) {
  const navigate = useNavigate()
  const [authModal, setAuthModal] = useState(null)
  const [navClass, setNavClass] = useState('')
  const [linkStyle, setLinkStyle] = useState('light')
  const isLoggedIn = !!session
  const openLogin = () => setAuthModal('login')
  const openSignup = () => setAuthModal('signup')
  const closeModal = () => setAuthModal(null)
  const handleAuthSuccess = () => { closeModal(); navigate('/') }
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
  useEffect(() => {
    const updateNav = () => {
      const darkZone = document.querySelector('.lg-dark')
      if (!darkZone) return
      const scrollY = window.scrollY
      const darkTop = darkZone.offsetTop
      const darkBottom = darkTop + darkZone.offsetHeight
      const inDark = scrollY + 60 > darkTop && scrollY + 60 < darkBottom
      if (scrollY > 60) {
        setNavClass(inDark ? 'scrolled-dark' : 'scrolled-light')
        setLinkStyle(inDark ? 'dark' : 'light')
      } else { setNavClass(''); setLinkStyle('light') }
    }
    window.addEventListener('scroll', updateNav)
    return () => window.removeEventListener('scroll', updateNav)
  }, [])
  useEffect(() => {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e, i) => {
        if (e.isIntersecting) { setTimeout(() => e.target.classList.add('visible'), i * 100); obs.unobserve(e.target) }
      })
    }, { threshold: 0.08 })
    document.querySelectorAll('.lg-reveal,.lg-reveal-left,.lg-reveal-right').forEach(el => obs.observe(el))
    return () => obs.disconnect()
  }, [])

  const CATEGORIES = [
    { ic: '🍽️', t: 'Meals', sub: 'Client, travel' },
    { ic: '✈️', t: 'Travel', sub: 'Flights, hotels' },
    { ic: '🚗', t: 'Mileage', sub: 'Standard rate' },
    { ic: '💻', t: 'Software', sub: 'Subscriptions' },
    { ic: '🖥️', t: 'Equipment', sub: 'Tools, tech' },
    { ic: '📎', t: 'Office', sub: 'Supplies' },
    { ic: '📣', t: 'Advertising', sub: 'Marketing' },
    { ic: '⚖️', t: 'Pro Services', sub: 'Legal, CPA' },
    { ic: '📚', t: 'Education', sub: 'Courses, books' },
    { ic: '📱', t: 'Phone', sub: 'Cell, internet' },
    { ic: '🏢', t: 'Rent', sub: 'Office, studio' },
    { ic: '🧾', t: 'Other', sub: 'Custom' },
  ]
  const WHO = [
    { ic: '🔧', t: 'Tradespeople', d: 'Plumbers, electricians, HVAC. Parts, supplies, job-site miles — all logged in one pocket.' },
    { ic: '🎨', t: 'Artists & creatives', d: 'Photographers, designers, illustrators. Studio supplies, client travel, gear.' },
    { ic: '🚗', t: 'Rideshare & delivery', d: 'Uber, Lyft, DoorDash. Log manually or import annual tax summaries.' },
    { ic: '🏡', t: 'Realtors', d: 'Open houses, showings, closing lunches. Every mile, every receipt.' },
    { ic: '💼', t: 'Consultants', d: 'Client meetings, travel, software. Your clean expense trail, every month.' },
    { ic: '📦', t: 'Side hustles', d: 'Etsy, craft fairs, weekend gigs. Simple tracking for extra 1099 income.' },
  ]

  return (
    <div className="lg-root">
      <div className="lg-bilingual-banner" style={{position:'fixed',top:0,left:0,right:0,zIndex:101,background:'linear-gradient(90deg, #0D9488 0%, #14B8A6 100%)',color:'#fff',padding:'8px 20px',textAlign:'center',fontSize:'13px',fontWeight:700,letterSpacing:'0.3px',display:'flex',justifyContent:'center',alignItems:'center',gap:'10px',flexWrap:'wrap',height:'36px',boxSizing:'border-box'}}>
          <span>Now available in English &amp; Español</span>
        </div>
      <GlobalStyle />
      {authModal && <AuthModal mode={authModal} onClose={closeModal} onSuccess={handleAuthSuccess} />}
      <nav className={`lg-nav ${navClass}`}>
        <button className="lg-nav-logo" onClick={() => window.scrollTo({top:0,behavior:'smooth'})}>Merq<span>Log</span></button>
        <div className="lg-nav-links">
          <button className={`lg-nav-link ${linkStyle}`} onClick={() => scrollTo('how')}>How it works</button>
          <button className={`lg-nav-link ${linkStyle}`} onClick={() => scrollTo('who')}>Who it's for</button>
          <button className={`lg-nav-link ${linkStyle}`} onClick={() => scrollTo('pricing')}>Pricing</button>
          {isLoggedIn ? (
            <button className="lg-nav-cta" onClick={() => navigate('/')}>Go to app →</button>
          ) : (
            <>
              <button className="lg-nav-login" onClick={openLogin}>Log in</button>
              <button className="lg-nav-cta" onClick={openSignup}>Start free →</button>
            </>
          )}
        </div>
      </nav>

      <section className="lg-hero">
        <div className="lg-orb lg-orb1" /><div className="lg-orb lg-orb2" /><div className="lg-orb lg-orb3" />
        <div className="lg-hero-left">
          <div className="lg-pill"><span className="lg-pill-dot" />Receipts · Miles · Tax-ready PDF</div>
          <h1 className="lg-h1">
            Your shoebox,<br/>
            <span className="grad-acc" style={{fontStyle:'italic',fontFamily:"'Fraunces',serif"}}>solved.</span>
          </h1>
          <p className="lg-hero-sub">Snap receipts. Log miles. At month-end, download one clean PDF with <strong>every expense, every mile, every receipt image</strong> — ready for your CPA. <strong>No bank login. No ads. $29 a year.</strong></p>
          <div className="lg-hero-actions">
            {isLoggedIn ? (
              <button className="lg-btn-primary" onClick={() => navigate('/')}>Go to your dashboard →</button>
            ) : (
              <>
                <button className="lg-btn-primary" onClick={openSignup}>Start 14-day free trial →</button>
                <button className="lg-btn-ghost-dark" onClick={() => scrollTo('sample')}>See a sample PDF</button>
              </>
            )}
          </div>
          <div className="lg-hero-trust">
            <span className="lg-trust-item">No credit card</span><span className="lg-trust-div" />
            <span className="lg-trust-item">Cancel anytime</span><span className="lg-trust-div" />
            <span className="lg-trust-item">$29/year</span>
          </div>
        </div>
        <div className="lg-hero-right">
          <div className="lg-pdf-wrap">
            <div className="lg-badge lg-badge1"><span style={{fontSize:'20px'}}>📷</span><div><div>Receipt scanned</div><div style={{fontSize:'10px',fontWeight:600,color:'var(--accent)'}}>AI auto-filled</div></div></div>
            <div className="lg-badge lg-badge2"><span style={{fontSize:'20px'}}>🚗</span><div><div>42 miles logged</div><div style={{fontSize:'10px',fontWeight:600,color:'var(--accent)'}}>$29.40 deduction</div></div></div>
            <div className="lg-badge lg-badge3"><span style={{fontSize:'20px'}}>📄</span><div><div>March PDF ready</div><div style={{fontSize:'10px',fontWeight:600,color:'var(--accent)'}}>Receipts attached</div></div></div>
            <div className="lg-pdf">
              <div className="lg-pdf-hdr">
                <div className="lg-pdf-brand">Merq<span>Log</span></div>
                <div className="lg-pdf-title">March 2026 Expense Report</div>
                <div className="lg-pdf-sub">PHILIP VIVIER · GENERATED APR 1, 2026</div>
              </div>
              <div className="lg-pdf-body">
                <div className="lg-pdf-stat-row">
                  <div className="lg-pdf-stat"><div className="lg-pdf-stat-l">Receipts</div><div className="lg-pdf-stat-v">32</div></div>
                  <div className="lg-pdf-stat"><div className="lg-pdf-stat-l">Miles</div><div className="lg-pdf-stat-v">487</div></div>
                  <div className="lg-pdf-stat"><div className="lg-pdf-stat-l">Total</div><div className="lg-pdf-stat-v pos">$4,588</div></div>
                </div>
                <div className="lg-pdf-table">
                  <div className="lg-pdf-row lg-pdf-row-hd"><span>Date</span><span>Merchant</span><span style={{textAlign:'right'}}>Amount</span></div>
                  <div className="lg-pdf-row"><span>Mar 14</span><span className="lg-pdf-merchant">Home Depot</span><span className="lg-pdf-amt">$142.08</span></div>
                  <div className="lg-pdf-row"><span>Mar 16</span><span className="lg-pdf-merchant">Adobe CC</span><span className="lg-pdf-amt">$54.99</span></div>
                  <div className="lg-pdf-row"><span>Mar 22</span><span className="lg-pdf-merchant">Mileage (42 mi)</span><span className="lg-pdf-amt">$29.40</span></div>
                  <div className="lg-pdf-row lg-pdf-row-ttl"><span></span><span>Page 1 total</span><span className="lg-pdf-amt">$226.47</span></div>
                </div>
                <div className="lg-pdf-foot"><span>🧾</span>Receipt images attached · Pages 2–8</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="lg-wave" />

      <div className="lg-dark">
        <section id="how" className="lg-how">
          <div className="lg-how-in">
            <div className="lg-how-hdr lg-reveal">
              <div className="lg-eyebrow">Three steps. That's it.</div>
              <h2 className="lg-big-h">Simple enough<br/><span className="grad-acc" style={{fontStyle:'italic',fontFamily:"'Fraunces',serif"}}>to actually use.</span></h2>
            </div>
            <div className="lg-how-steps">
              <div className="lg-how-step lg-reveal">
                <div className="lg-how-num">01</div>
                <div className="lg-how-t">Snap a receipt.</div>
                <div className="lg-how-d">Point your phone at any receipt. Crumpled, faded, foreign — AI reads it in seconds. Merchant, date, amount, category. All filled in automatically.</div>
              </div>
              <div className="lg-how-step lg-reveal">
                <div className="lg-how-num">02</div>
                <div className="lg-how-t">Log a trip.</div>
                <div className="lg-how-d">Type the address, we autocomplete. Distance calculated automatically. Save your regular clients and log trips with one tap. 2026 IRS rate applied.</div>
              </div>
              <div className="lg-how-step lg-reveal">
                <div className="lg-how-num">03</div>
                <div className="lg-how-t">Get the PDF.</div>
                <div className="lg-how-d">Monthly or annual. Cover page, line items, category totals, mileage deduction, every receipt image attached. Hand it to your CPA. Done.</div>
              </div>
            </div>
          </div>
        </section>

        <section className="lg-mileage">
          <div className="lg-mileage-in">
            <div className="lg-reveal-left">
              <div className="lg-eyebrow">Mileage, done right</div>
              <h2 className="lg-big-h">Type the address.<br/><span className="grad-acc" style={{fontStyle:'italic',fontFamily:"'Fraunces',serif"}}>We do the math.</span></h2>
              <p className="lg-body-txt">Google Places autocomplete. Distance calculated automatically. Save your regular stops — the hardware store, your main client, your studio. One tap and you're logged.</p>
              <div className="lg-fl">
                <div className="lg-fli"><div className="lg-f-num">✓</div><div><div className="lg-f-title">No GPS, no battery drain</div><div className="lg-f-desc">You know where you went. We just make it easy to log it.</div></div></div>
                <div className="lg-fli"><div className="lg-f-num">✓</div><div><div className="lg-f-title">IRS-compliant records</div><div className="lg-f-desc">Date, miles, destination, purpose — every requirement met per IRS Pub 463.</div></div></div>
                <div className="lg-fli"><div className="lg-f-num">✓</div><div><div className="lg-f-title">Round-trip, one tap</div><div className="lg-f-desc">Coming back? Toggle the switch. Miles doubled automatically.</div></div></div>
              </div>
            </div>
            <div className="lg-reveal-right">
              <div className="lg-mile-card">
                <div style={{fontSize:'12px',color:'var(--muted-light)',textTransform:'uppercase',letterSpacing:'0.08em',fontWeight:700,marginBottom:'4px'}}>March Mileage</div>
                <div style={{fontFamily:'Fraunces,serif',fontSize:'22px',fontWeight:800,color:'var(--text-light)',marginBottom:'16px'}}>487 business miles</div>
                <div className="lg-mile-trip">
                  <div className="lg-mile-ic">🏠</div>
                  <div><div className="lg-mile-info">Home → Home Depot</div><div className="lg-mile-sub">Mar 14 · Supplies run</div></div>
                  <div className="lg-mile-val"><div className="lg-mile-mi">18 mi</div><div className="lg-mile-ded">$12.60</div></div>
                </div>
                <div className="lg-mile-trip">
                  <div className="lg-mile-ic">🏢</div>
                  <div><div className="lg-mile-info">Home → Johnson residence</div><div className="lg-mile-sub">Mar 16 · Job site · round trip</div></div>
                  <div className="lg-mile-val"><div className="lg-mile-mi">42 mi</div><div className="lg-mile-ded">$29.40</div></div>
                </div>
                <div className="lg-mile-trip">
                  <div className="lg-mile-ic">🛠️</div>
                  <div><div className="lg-mile-info">Home → Parts depot</div><div className="lg-mile-sub">Mar 22 · Supplies run</div></div>
                  <div className="lg-mile-val"><div className="lg-mile-mi">27 mi</div><div className="lg-mile-ded">$18.90</div></div>
                </div>
                <div className="lg-mile-ttl">
                  <div className="lg-mile-ttl-l">Mar Deduction</div>
                  <div className="lg-mile-ttl-v">$340.90</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="lg-cat">
          <div className="lg-cat-in">
            <div className="lg-cat-hdr lg-reveal">
              <div className="lg-eyebrow">Tax-code categories</div>
              <h2 className="lg-big-h">Every expense, <span className="grad-acc" style={{fontStyle:'italic',fontFamily:"'Fraunces',serif"}}>in the right bucket.</span></h2>
              <p className="lg-body-txt" style={{margin:'16px auto 0',textAlign:'center'}}>Categories match IRS Schedule C. Your CPA sees exactly what they expect — no translation needed.</p>
            </div>
            <div className="lg-cat-grid lg-reveal">
              {CATEGORIES.map((c,i) => (
                <div key={i} className="lg-cat-c">
                  <div className="lg-cat-ic">{c.ic}</div>
                  <div className="lg-cat-t">{c.t}</div>
                  <div className="lg-cat-sub">{c.sub}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="who" className="lg-who">
          <div className="lg-who-in">
            <div className="lg-who-hdr lg-reveal">
              <div className="lg-eyebrow">Who it's for</div>
              <h2 className="lg-big-h">For the rest<br/><span className="grad-acc" style={{fontStyle:'italic',fontFamily:"'Fraunces',serif"}}>of us.</span></h2>
              <p className="lg-body-txt" style={{margin:'16px auto 0',textAlign:'center'}}>If you file a Schedule C, this is for you. Doesn't matter what you do.</p>
            </div>
            <div className="lg-who-grid lg-reveal">
              {WHO.map((w,i) => (
                <div key={i} className="lg-who-c">
                  <div className="lg-who-ic">{w.ic}</div>
                  <div className="lg-who-t">{w.t}</div>
                  <div className="lg-who-d">{w.d}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="bilingual" className="lg-how">
          <div className="lg-how-in lg-reveal" style={{textAlign:'center'}}>
            <div className="lg-eyebrow">English &amp; Español</div>
            <h2 className="lg-how-h" style={{fontFamily:'Fraunces,serif',fontSize:'clamp(36px,5vw,56px)',fontWeight:900,lineHeight:1.1,color:'var(--text-light)',marginBottom:'20px'}}>We work in<br/><em style={{fontStyle:'italic',color:'var(--accent-l)'}}>your language.</em></h2>
            <p className="lg-how-p" style={{maxWidth:'680px',margin:'0 auto',color:'var(--muted-light)',fontSize:'17px',lineHeight:1.7}}>Same <strong>Schedule C</strong>. Same <strong>IRS</strong>. Now in <strong>Español</strong>. Every screen, every report, every receipt category — fully translated for the millions of US self-employed who think, work, and file in two languages. Switch anytime in Settings.</p>
            <div className="lg-bilingual-flags" style={{display:'flex',gap:'24px',justifyContent:'center',marginTop:'24px',fontSize:'14px',fontWeight:700,color:'var(--muted-light)'}}>
              <span style={{display:'inline-flex',alignItems:'center',gap:'8px'}}><span style={{fontSize:'20px'}}>🇺🇸</span>English</span>
              <span style={{opacity:0.4}}>·</span>
              <span style={{display:'inline-flex',alignItems:'center',gap:'8px'}}>Español</span>
            </div>
          </div>
        </section>

        <section id="sample" className="lg-sample">
          <div className="lg-sample-in lg-reveal">
            <div className="lg-eyebrow">See a real report</div>
            <h2 className="lg-sample-h">One PDF. Every deduction.<br/><em style={{fontStyle:'italic',color:'var(--accent-l)'}}>Audit-ready documentation.</em></h2>
            <p className="lg-sample-p">Cover page with totals by category. Line-item table sorted by date. Mileage deduction calculated. Every receipt image attached as a page. IRS-compliant digital copies (Pub. 463 + Rev. Proc. 97-22). Everything your accountant needs, nothing more.</p>
            <a href="/merq-expense-report-sample.pdf" target="_blank" rel="noopener noreferrer" className="lg-sample-btn">Download a real sample PDF →</a>
          </div>
        </section>

        <section id="pricing" className="lg-price">
          <div className="lg-price-in lg-reveal">
            <div className="lg-price-hdr">
              <div className="lg-eyebrow">Honest pricing</div>
              <h2 className="lg-big-h">One price.<br/><span className="grad-acc" style={{fontStyle:'italic',fontFamily:"'Fraunces',serif"}}>Everything included.</span></h2>
              <p style={{fontSize:'17px',color:'var(--muted-light)',marginTop:'16px',lineHeight:'1.7'}}>No per-user fees. No tiers. No upsell traps.</p>
            </div>
            <div className="lg-pc">
              <div className="lg-pc-eyebrow">Annual · One plan</div>
              <div className="lg-pc-name">Merq Log</div>
              <div className="lg-pc-price"><sup>$</sup>29</div>
              <div className="lg-pc-period">per year · ~$2.42/mo</div>
              <div className="lg-pc-note">14-day free trial · No credit card required</div>
              <div className="lg-pc-feats">
                <div className="lg-pc-feat-item">Unlimited AI receipt scanning</div>
                <div className="lg-pc-feat-item">Unlimited mileage logging</div>
                <div className="lg-pc-feat-item">Monthly & annual PDF reports</div>
                <div className="lg-pc-feat-item">IRS Schedule C categories</div>
                <div className="lg-pc-feat-item">Google Maps distance lookup</div>
                <div className="lg-pc-feat-item">Saved addresses & vehicles</div>
                <div className="lg-pc-feat-item">Email support</div>
                <div className="lg-pc-feat-item">Bootstrapped. Made in Texas.</div>
              </div>
              {isLoggedIn ? (
                <button className="lg-pc-cta" onClick={() => navigate('/')}>Go to your dashboard →</button>
              ) : (
                <button className="lg-pc-cta" onClick={openSignup}>Start 14-day free trial →</button>
              )}
            </div>
            <div style={{marginTop:'24px',fontSize:'13px',color:'var(--muted-light)'}}>No credit card · Cancel anytime · Secure checkout by Paddle</div>
          </div>
        </section>
      </div>

      <div className="lg-wave-rev" />

      <section className="lg-cta">
        <div className="lg-cta-in lg-reveal">
          <h2 className="lg-cta-h">Tax time,<br/><span className="grad-acc" style={{fontStyle:'italic',fontFamily:"'Fraunces',serif"}}>handled.</span></h2>
          <p className="lg-cta-sub">Stop stuffing receipts in a shoebox. 14 days free. No credit card. Just clarity.</p>
          {isLoggedIn ? (
            <button className="lg-btn-primary lg-btn-primary-lg" onClick={() => navigate('/')}>Go to your dashboard →</button>
          ) : (
            <button className="lg-btn-primary lg-btn-primary-lg" onClick={openSignup}>Start your free trial →</button>
          )}
          <div style={{marginTop:'16px',fontSize:'13px',color:'var(--muted-dark)'}}>No credit card · Cancel anytime · Secure checkout by Paddle</div>
        </div>
      </section>

      <footer className="lg-footer">
        <div className="lg-foot-in">
          <div>
            <button className="lg-foot-logo" onClick={() => window.scrollTo({top:0,behavior:'smooth'})}>Merq<span>Log</span></button>
            <div className="lg-foot-sub">Receipts and miles. That's it. Built for the rest of us — bootstrapped, honest, made in Texas.</div>
          </div>
          <div className="lg-foot-col">
            <h4>Product</h4>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a onClick={e=>{e.preventDefault();scrollTo('how')}}>How it works</a>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a onClick={e=>{e.preventDefault();scrollTo('who')}}>Who it's for</a>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a onClick={e=>{e.preventDefault();scrollTo('pricing')}}>Pricing</a>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a onClick={e=>{e.preventDefault();openSignup()}}>Start free trial</a>
          </div>
          <div className="lg-foot-col">
            <h4>Merq Suite</h4>
            <a href="https://merqvault.com">Merq Vault</a>
            <a href="https://merq-edge.vercel.app">Merq Edge</a>
            <a href="https://merqlegacy.com">Merq Legacy</a>
            <a href="https://getmerq.com">Merq Software</a>
            <a href="mailto:hello@getmerq.com">Contact</a>
          </div>
        </div>
        <div className="lg-foot-btm">
          <div className="lg-foot-copy">© 2026 Merq Software · Texas · hello@getmerq.com</div>
          <div className="lg-foot-copy">Not tax advice. Consult your CPA.</div>
        </div>
      </footer>
    
      {/* MERQ_LOG_LEGAL_FOOTER_v2 */}
      <footer style={legalFooterStyles.footer}>
        <div style={legalFooterStyles.footerInner}>
          <div style={legalFooterStyles.footerBrand}>
            <span>
              Merq<span style={legalFooterStyles.footerLogAccent}>Log</span>
            </span>
            <span style={legalFooterStyles.footerCopyright}>
              © 2026 Merq Software · Texas, United States
            </span>
          </div>
          <div style={legalFooterStyles.footerLinks}>
            <Link to="/privacy" style={legalFooterStyles.footerLink}>Privacy</Link>
            <Link to="/terms" style={legalFooterStyles.footerLink}>Terms</Link>
            <Link to="/refunds" style={legalFooterStyles.footerLink}>Refunds</Link>
            <Link to="/contact" style={legalFooterStyles.footerLink}>Contact</Link>
            <a href="mailto:hello@getmerq.com" style={legalFooterStyles.footerLink}>hello@getmerq.com</a>
          </div>
        </div>
      </footer>
</div>
  )
}

const legalFooterStyles = {
  footer: { background: '#1E1040', color: '#FAF7F2', padding: '40px 24px 32px', marginTop: '60px' },
  footerInner: { maxWidth: '1100px', margin: '0 auto', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: '20px', fontFamily: "'Plus Jakarta Sans', sans-serif" },
  footerBrand: { fontFamily: "'Fraunces', serif", fontSize: '20px', fontWeight: 900, letterSpacing: '-0.5px', display: 'flex', flexDirection: 'column', gap: '6px' },
  footerLogAccent: { color: '#0D9488', fontStyle: 'italic' },
  footerCopyright: { fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: '12px', fontWeight: 500, color: 'rgba(250, 247, 242, 0.6)', letterSpacing: '0' },
  footerLinks: { display: 'flex', flexWrap: 'wrap', gap: '20px', alignItems: 'center' },
  footerLink: { color: '#FAF7F2', textDecoration: 'none', fontSize: '13px', fontWeight: 600, opacity: 0.8 },
}

